module.exports = __webpack_public_path__ + "img/Logo_Petzl.13f92bfb.svg";